const config = {
  baseURL: `apis`,
  timeout: 100000,
};

export default config;
